import React, { FC } from 'react';

interface IProps {
  width?: number;
  height?: number;
  color: string;
}

const AppleIcon: FC<IProps> = ({ width, height, color }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 34 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.4731 40.0008C5.5199 39.9665 0.59552 27.814 0.59552 21.6251C0.59552 11.5154 8.1795 9.30209 11.1023 9.30209C12.4195 9.30209 13.826 9.81936 15.0665 10.2771C15.934 10.5964 16.8312 10.926 17.3302 10.926C17.6289 10.926 18.3327 10.6456 18.9541 10.3996C20.2793 9.87201 21.9284 9.21631 23.8487 9.21631C23.8522 9.21631 23.8568 9.21631 23.8601 9.21631C25.294 9.21631 29.6417 9.531 32.2555 13.4563L32.8678 14.3764L31.9866 15.0413C30.7278 15.9912 28.4309 17.7238 28.4309 21.1559C28.4309 25.2208 31.0322 26.7841 32.2818 27.536C32.8335 27.8679 33.4045 28.2101 33.4045 28.9585C33.4045 29.4472 29.5043 39.9402 23.8407 39.9402C22.4548 39.9402 21.4752 39.5237 20.6111 39.1563C19.7368 38.7844 18.9826 38.464 17.7364 38.464C17.1047 38.464 16.3058 38.7626 15.4601 39.0797C14.3044 39.511 12.9963 40.0008 11.512 40.0008H11.4731Z"
      fill={color}
    />
    <path
      d="M24.4488 0C24.5963 5.31844 20.7928 9.00813 16.9937 8.77672C16.3677 4.53242 20.7923 0 24.4488 0Z"
      fill={color}
    />
  </svg>
);

export { AppleIcon };
